var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSeason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4829_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.333 3.33398V2.91732C18.333 2.36478 18.1135 1.83488 17.7228 1.44418C17.3321 1.05348 16.8022 0.833984 16.2497 0.833984C15.6971 0.833984 15.1672 1.05348 14.7765 1.44418C14.3858 1.83488 14.1663 2.36478 14.1663 2.91732V3.33398C13.708 3.33398 13.333 3.70898 13.333 4.16732V7.50065C13.333 7.95898 13.708 8.33398 14.1663 8.33398H18.333C18.7913 8.33398 19.1663 7.95898 19.1663 7.50065V4.16732C19.1663 3.70898 18.7913 3.33398 18.333 3.33398ZM17.6663 3.33398H14.833V2.91732C14.833 2.13398 15.4663 1.50065 16.2497 1.50065C17.033 1.50065 17.6663 2.13398 17.6663 2.91732V3.33398ZM15.7663 10.0007C15.7997 10.2757 15.833 10.5506 15.833 10.834C15.833 12.5673 15.1663 14.1423 14.083 15.3256C13.8663 14.6506 13.2497 14.1673 12.4997 14.1673H11.6663V11.6673C11.6663 11.209 11.2913 10.834 10.833 10.834H5.83301V9.16732H7.49967C7.95801 9.16732 8.33301 8.79232 8.33301 8.33398V6.66732H9.99967C10.9163 6.66732 11.6663 5.91732 11.6663 5.00065V2.88398C10.8747 2.63398 10.0413 2.50065 9.16634 2.50065C4.56634 2.50065 0.833008 6.23398 0.833008 10.834C0.833008 15.434 4.56634 19.1673 9.16634 19.1673C13.7663 19.1673 17.4997 15.434 17.4997 10.834C17.4997 10.5506 17.483 10.2757 17.458 10.0007H15.7663ZM8.33301 17.4423C5.04134 17.034 2.49967 14.234 2.49967 10.834C2.49967 10.3173 2.56634 9.82565 2.67467 9.34232L6.66634 13.334V14.1673C6.66634 15.084 7.41634 15.834 8.33301 15.834V17.4423Z",
    fill: "#030303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4829_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSeason);
export default __webpack_public_path__ + "static/media/close_season.dc0fd45e0967accfda019287f95c7f4b.svg";
export { ForwardRef as ReactComponent };